import styled from 'styled-components';

export const SMarginTop = styled.div`
  height: 18%;
`;

export const SLogo = styled.div`
  height: 15%;
  margin-top: 65px;
  width: auto;
`;

export const SConfirmationIcon = styled.div`
  margin-bottom: 40px;
`;

export const STitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 45px;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 45px;
  margin-bottom: 47.5px;
  white-space: nowrap;

  * {
    display: block;
  }

  .light {
    color: ${({ theme }) => theme.colors.primary};
  }

  .dark {
    color: ${({ theme }) => theme.colors.primaryText};
  }
`;
